/*global-options*/
/*extends*/
/*globaldependencies*/
/*globalenv*/
/*globalpassthroughenv*/
/*ui*/
/*noupdatenotifier*/
/*concurrency*/
/*dangerouslydisablepackagemanagercheck*/
/*cachedir*/
/*daemon*/
/*envmode*/
/*futureflags*/
/*tags-experimentalbadgeexperimentalexperimentalbadge*/
/*defining-tasks*/
/*tasks*/
/*task-options*/
/*extends-task-level*/
/*dependson*/
/*dependency-relationships*/
/*same-package-relationships*/
/*arbitrary-task-relationships*/
/*env*/
/*wildcards*/
/*negation*/
/*examples*/
/*passthroughenv*/
/*outputs*/
/*cache*/
/*inputs*/
/*turbodefault*/
/*turboroot*/
/*turboextends*/
/*outputlogs*/
/*persistent*/
/*interactive*/
/*interruptible*/
/*with*/
/*boundaries*/
/*tags*/
/*dependencies-and-dependents*/
/*remote-caching*/
/*enabled*/
/*signature*/
/*preflight*/
/*timeout*/
/*uploadtimeout*/
/*apiurl*/
/*loginurl*/
/*teamid*/
/*teamslug*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "配置 turbo.json",
  "description": "了解如何通过 `turbo.json` 配置 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "使用工作区根目录中的 turbo.json 文件配置 turbo 的行为。你还可以："
  }, {
    "heading": "",
    "content": "¥Configure the behavior of turbo by using a turbo.json file in your Workspace's root directory. You can also:"
  }, {
    "heading": "",
    "content": "使用 软件包配置 进行更精细的控制。"
  }, {
    "heading": "",
    "content": "¥Use Package Configurations for more granular control."
  }, {
    "heading": "",
    "content": "使用 turbo.jsonc 为你的配置添加注释，并借助 IDE 支持。"
  }, {
    "heading": "",
    "content": "¥Use turbo.jsonc to add comments to your configuration with IDE support."
  }, {
    "heading": "全局选项-global-options",
    "content": "¥Global options"
  }, {
    "heading": "extends-extends",
    "content": "从根 turbo.json 扩展，使用 软件包配置 为包创建特定配置。"
  }, {
    "heading": "extends-extends",
    "content": "¥Extend from the root turbo.json to create specific configuration for a package using Package Configurations."
  }, {
    "heading": "extends-extends",
    "content": "要从根包的 turbo.json 继承配置，extends 数组必须以 [\"//\"] 开头。"
  }, {
    "heading": "extends-extends",
    "content": "¥The extends array must start with [\"//\"] to inherit configuration from the root turbo.json."
  }, {
    "heading": "extends-extends",
    "content": "你还可以从其他包（例如 [\"//\", \"shared-config\"]）扩展。"
  }, {
    "heading": "extends-extends",
    "content": "¥You can also extend from other packages (e.g., [\"//\", \"shared-config\"])."
  }, {
    "heading": "extends-extends",
    "content": "如果在根 turbo.json 中使用 extends，它将被忽略。"
  }, {
    "heading": "extends-extends",
    "content": "¥If extends is used in the root turbo.json, it will be ignored."
  }, {
    "heading": "globaldependencies-globaldependencies",
    "content": "要包含在所有任务哈希中的全局变量列表。如果任何与这些全局变量匹配的文件发生更改，所有任务都将丢失缓存。Globs 是相对于 turbo.json 位置的。"
  }, {
    "heading": "globaldependencies-globaldependencies",
    "content": "¥A list of globs that you want to include in all task hashes. If any file matching these globs changes, all tasks will miss cache. Globs are relative to the location of turbo.json."
  }, {
    "heading": "globaldependencies-globaldependencies",
    "content": "默认情况下，全局哈希 仅包含根 package.json 和 lockfile，并且不能忽略。任何添加的 globalDependencies 也将包含在全局哈希中。"
  }, {
    "heading": "globaldependencies-globaldependencies",
    "content": "¥By default, only the root package.json and lockfile are included in the global hash and can't be ignored. Any added globalDependencies will also be included in the global hash."
  }, {
    "heading": "globaldependencies-globaldependencies",
    "content": "Globs 必须位于仓库的源代码控制根目录。不支持仓库外的 Glob。"
  }, {
    "heading": "globaldependencies-globaldependencies",
    "content": "¥Globs must be in the repository's source control root. Globs outside of the\nrepository aren't supported."
  }, {
    "heading": "globalenv-globalenv",
    "content": "你希望影响所有任务哈希值的环境变量列表。对这些环境变量的任何更改都会导致所有任务缓存未命中。"
  }, {
    "heading": "globalenv-globalenv",
    "content": "¥A list of environment variables that you want to impact the hash of all tasks. Any change to these environment variables will cause all tasks to miss cache."
  }, {
    "heading": "globalenv-globalenv",
    "content": "关于通配符和否定语法的更多信息，请参阅 参见 env 部分。"
  }, {
    "heading": "globalenv-globalenv",
    "content": "¥For more on wildcard and negation syntax, see the env section."
  }, {
    "heading": "globalpassthroughenv-globalpassthroughenv",
    "content": "你希望对任务可用的环境变量列表。使用此键会将所有任务添加到 严格环境变量模式 中。"
  }, {
    "heading": "globalpassthroughenv-globalpassthroughenv",
    "content": "¥A list of environment variables that you want to make available to tasks. Using this key opts all tasks into Strict Environment Variable Mode."
  }, {
    "heading": "globalpassthroughenv-globalpassthroughenv",
    "content": "此外，Turborepo 内置了一组全局传递变量，用于常见情况，例如操作系统环境变量。这包括 HOME、PATH、APPDATA、SHELL、PWD 等变量。完整列表可在 在源代码中 中找到。"
  }, {
    "heading": "globalpassthroughenv-globalpassthroughenv",
    "content": "¥Additionally, Turborepo has a built-in set of global passthrough variables for common cases, like operating system environment variables. This includes variables like HOME, PATH, APPDATA, SHELL, PWD, and more. The full list can be found in the source code."
  }, {
    "heading": "globalpassthroughenv-globalpassthroughenv",
    "content": "如果你希望这些变量的更改导致缓存未命中，则需要将它们包含在 env 或 globalEnv 中。"
  }, {
    "heading": "globalpassthroughenv-globalpassthroughenv",
    "content": "¥If you want changes in these variables to cause cache misses, you will need to\ninclude them in env or globalEnv."
  }, {
    "heading": "ui-ui",
    "content": "默认：\"stream\""
  }, {
    "heading": "ui-ui",
    "content": "¥Default: \"stream\""
  }, {
    "heading": "ui-ui",
    "content": "为存储库选择一个终端 UI。"
  }, {
    "heading": "ui-ui",
    "content": "¥Select a terminal UI for the repository."
  }, {
    "heading": "ui-ui",
    "content": "\"tui\" 允许一次性查看每个日志并与任务交互。\"stream\" 会在日志输入时输出日志，并且不可交互。"
  }, {
    "heading": "ui-ui",
    "content": "¥\"tui\" allows for viewing each log at once and interacting with the task. \"stream\" outputs logs as they come in and is not interactive."
  }, {
    "heading": "noupdatenotifier-noupdatenotifier",
    "content": "默认：false"
  }, {
    "heading": "noupdatenotifier-noupdatenotifier",
    "content": "¥Default: false"
  }, {
    "heading": "noupdatenotifier-noupdatenotifier",
    "content": "设置为 true 时，将禁用 turbo 新版本可用时显示的更新通知。"
  }, {
    "heading": "noupdatenotifier-noupdatenotifier",
    "content": "¥When set to true, disables the update notification that appears when a new version of turbo is available."
  }, {
    "heading": "concurrency-concurrency",
    "content": "默认：\"10\""
  }, {
    "heading": "concurrency-concurrency",
    "content": "¥Default: \"10\""
  }, {
    "heading": "concurrency-concurrency",
    "content": "设置/限制任务执行的最大并发数。必须是大于或等于 1 的整数，或者像 50% 这样的百分比值。"
  }, {
    "heading": "concurrency-concurrency",
    "content": "¥Set/limit the maximum concurrency for task execution. Must be an integer greater than or equal to 1 or a percentage value like 50%."
  }, {
    "heading": "concurrency-concurrency",
    "content": "使用 1 强制串行执行（一次执行一个任务）。"
  }, {
    "heading": "concurrency-concurrency",
    "content": "¥Use 1 to force serial execution (one task at a time)."
  }, {
    "heading": "concurrency-concurrency",
    "content": "使用 100% 使用所有可用的逻辑处理器。"
  }, {
    "heading": "concurrency-concurrency",
    "content": "¥Use 100% to use all available logical processors."
  }, {
    "heading": "concurrency-concurrency",
    "content": "如果同时传递了 --parallel 标志，则此选项将被忽略。"
  }, {
    "heading": "concurrency-concurrency",
    "content": "¥This option is ignored if the --parallel flag is also passed."
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "默认：false"
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "¥Default: false"
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "Turborepo 使用你仓库的锁文件来确定缓存行为、软件包图表 等。因此，我们使用 packageManager 字段 来帮助你稳定 Turborepo。"
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "¥Turborepo uses your repository's lockfile to determine caching behavior, Package Graphs, and more. Because of this, we use the packageManager field to help you stabilize your Turborepo."
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "为了帮助增量迁移或在无法使用 packageManager 字段的情况下，你可以使用 --dangerously-disable-package-manager-check 退出此检查，并承担不稳定的锁文件产生不可预测行为的风险。禁用后，Turborepo 将尽力查找适用于该存储库的包管理器。"
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "¥To help with incremental migration or in situations where you can't use the packageManager field, you may use --dangerously-disable-package-manager-check to opt out of this check and assume the risks of unstable lockfiles producing unpredictable behavior. When disabled, Turborepo will attempt a best-effort discovery of the intended package manager meant for the repository."
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "你也可以通过 flag 或 TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK 环境变量选择退出此检查。"
  }, {
    "heading": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "¥You may also opt out of this check via\nflag or\nthe\nTURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK\nenvironment variable."
  }, {
    "heading": "cachedir-cachedir",
    "content": "默认：\".turbo/cache\""
  }, {
    "heading": "cachedir-cachedir",
    "content": "¥Default: \".turbo/cache\""
  }, {
    "heading": "cachedir-cachedir",
    "content": "指定文件系统缓存目录。"
  }, {
    "heading": "cachedir-cachedir",
    "content": "¥Specify the filesystem cache directory."
  }, {
    "heading": "daemon-daemon",
    "content": "默认：true"
  }, {
    "heading": "daemon-daemon",
    "content": "¥Default: true"
  }, {
    "heading": "daemon-daemon",
    "content": "Turborepo 会运行后台进程来预先计算一些开销很大的操作。此独立进程（守护进程）是一种性能优化，并非 turbo 正常运行所必需的。"
  }, {
    "heading": "daemon-daemon",
    "content": "¥Turborepo runs a background process to pre-calculate some expensive operations. This standalone process (daemon) is a performance optimization, and not required for proper functioning of turbo."
  }, {
    "heading": "daemon-daemon",
    "content": "在 CI 环境中运行时，无论此设置如何，守护进程始终处于禁用状态。"
  }, {
    "heading": "daemon-daemon",
    "content": "¥When running in a CI environment the daemon is always disabled regardless of\nthis setting."
  }, {
    "heading": "envmode-envmode",
    "content": "默认：\"strict\""
  }, {
    "heading": "envmode-envmode",
    "content": "¥Default: \"strict\""
  }, {
    "heading": "envmode-envmode",
    "content": "Turborepo 的环境模式允许你控制在运行时哪些环境变量可用于任务："
  }, {
    "heading": "envmode-envmode",
    "content": "¥Turborepo's Environment Modes allow you to control which environment variables are available to a task at runtime:"
  }, {
    "heading": "envmode-envmode",
    "content": "\"strict\"：将环境变量过滤为仅在 turbo.json 中的 env 和 globalEnv 键中指定的变量。"
  }, {
    "heading": "envmode-envmode",
    "content": "¥\"strict\": Filter environment variables to only those that are specified in the env and globalEnv keys in turbo.json."
  }, {
    "heading": "envmode-envmode",
    "content": "\"loose\"：允许进程的所有环境变量可用。"
  }, {
    "heading": "envmode-envmode",
    "content": "¥\"loose\": Allow all environment variables for the process to be available."
  }, {
    "heading": "envmode-envmode",
    "content": "了解更多关于 环境模式 的信息。"
  }, {
    "heading": "envmode-envmode",
    "content": "¥Read more about Environment Modes."
  }, {
    "heading": "futureflags-futureflags",
    "content": "启用将在 Turborepo 的未来版本中成为默认行为的实验性功能。"
  }, {
    "heading": "futureflags-futureflags",
    "content": "¥Enable experimental features that will become the default behavior in future versions of Turborepo."
  }, {
    "heading": "futureflags-futureflags",
    "content": "futureFlags 只能在根 turbo.json 中设置。如果在 软件包配置 中设置，将会抛出错误。"
  }, {
    "heading": "futureflags-futureflags",
    "content": "¥futureFlags can only be set in the root turbo.json. An error will be\nthrown if set in a Package\nConfiguration."
  }, {
    "heading": "futureflags-futureflags",
    "content": "目前没有未来标志。"
  }, {
    "heading": "futureflags-futureflags",
    "content": "¥There are no future flags at this time."
  }, {
    "heading": "tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "为包添加标签以便与 边界 一起使用。"
  }, {
    "heading": "tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "¥Adds a tag to a package for use with Boundaries."
  }, {
    "heading": "tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "此键仅在 软件包配置 中有效。在根 turbo.json 中使用此键将导致错误。"
  }, {
    "heading": "tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "¥This key only works in Package Configurations. Using this key in a root turbo.json will result in an error."
  }, {
    "heading": "定义任务-defining-tasks",
    "content": "¥Defining tasks"
  }, {
    "heading": "tasks-tasks",
    "content": "tasks 对象中的每个键都是一个可以由 turbo run 执行的任务名称。Turborepo 将在你的 工作区配置 中描述的包中搜索 package.json 中与任务名称相同的脚本。"
  }, {
    "heading": "tasks-tasks",
    "content": "¥Each key in the tasks object is the name of a task that can be executed by turbo run. Turborepo will search the packages described in your Workspace's configuration for scripts in package.json with the name of the task."
  }, {
    "heading": "tasks-tasks",
    "content": "使用任务中描述的其余配置，Turborepo 将按照描述的顺序运行脚本，并在提供日志和文件输出时将其缓存在 outputs 键 中。"
  }, {
    "heading": "tasks-tasks",
    "content": "¥Using the rest of the configuration described in the task, Turborepo will run the scripts in the described order, caching logs and file outputs in the outputs key when provided."
  }, {
    "heading": "tasks-tasks",
    "content": "在下面的示例中，我们在 tasks 键下定义了三个任务：build、test 和 dev。"
  }, {
    "heading": "tasks-tasks",
    "content": "¥In the example below, we've defined three tasks under the tasks key: build, test, and dev."
  }, {
    "heading": "任务选项-task-options",
    "content": "¥Task options"
  }, {
    "heading": "任务选项-task-options",
    "content": "使用你在 tasks 中定义的任务中可用的选项，你可以描述 turbo 将如何运行你的任务。"
  }, {
    "heading": "任务选项-task-options",
    "content": "¥Using the options available in the tasks you define in tasks, you can describe how turbo will run your tasks."
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "¥extends (task-level)"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "控制任务是否从继承链继承配置。此选项仅在 软件包配置 中可用，在根 turbo.json 中不可用。"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "¥Controls whether a task inherits configuration from the extends chain. This option is only available in Package Configurations, not in the root turbo.json."
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "值"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "行为"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "false"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "任务不参与继承。如果没有提供其他配置，则该任务不会存在于此包中。如果提供了其他配置，则会创建一个新的任务定义，并且不继承任何现有配置。"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "true（默认）"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "任务通常从 extends 链继承配置。"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "有关示例和更多详细信息，请参阅 从继承中排除任务。"
  }, {
    "heading": "extends任务级别-extends-task-level",
    "content": "¥See Excluding tasks from inheritance for examples and more details."
  }, {
    "heading": "dependson-dependson",
    "content": "在任务开始运行之前需要完成的任务列表。"
  }, {
    "heading": "dependson-dependson",
    "content": "¥A list of tasks that are required to complete before the task begins running."
  }, {
    "heading": "dependson-dependson",
    "content": "dependsOn 关系有三种类型：依赖、同包关系 和 任意任务关系。"
  }, {
    "heading": "dependson-dependson",
    "content": "¥There are three types of dependsOn relationships: dependency relationships, same-package relationships, and arbitrary task relationships."
  }, {
    "heading": "依赖-dependency-relationships",
    "content": "¥Dependency relationships"
  }, {
    "heading": "依赖-dependency-relationships",
    "content": "在 dependsOn 中的字符串前面加上 ^ 前缀，告诉 turbo 该任务必须先等待包依赖中的任务完成。例如，在下面的 turbo.json 中："
  }, {
    "heading": "依赖-dependency-relationships",
    "content": "¥Prefixing a string in dependsOn with a ^ tells turbo that the task must wait for tasks in the package's dependencies to complete first. For example, in the turbo.json below:"
  }, {
    "heading": "依赖-dependency-relationships",
    "content": "turbo 从包图的 \"bottom\" 开始，递归访问每个包，直到找到没有内部依赖的包。然后，它将首先运行依赖链末尾的 build 任务，然后返回 \"top\" 任务，直到所有 build 任务按顺序完成。"
  }, {
    "heading": "依赖-dependency-relationships",
    "content": "¥turbo starts at the \"bottom\" of the package graph and recursively visits each package until it finds a package with no internal dependencies. It will then run the build task at the end of the dependency chain first, working its way back to the \"top\" until all build tasks are completed in order."
  }, {
    "heading": "相同的包关系-same-package-relationships",
    "content": "¥Same package relationships"
  }, {
    "heading": "相同的包关系-same-package-relationships",
    "content": "不带 ^ 前缀的任务名称描述依赖于同一包中其他任务的任务。例如，在下面的 turbo.json 中："
  }, {
    "heading": "相同的包关系-same-package-relationships",
    "content": "¥Task names without the ^ prefix describe a task that depends on a different task within the same package. For example, in the turbo.json below:"
  }, {
    "heading": "相同的包关系-same-package-relationships",
    "content": "test 任务仅在 lint 和 build 任务在同一软件包中完成后才会运行。"
  }, {
    "heading": "相同的包关系-same-package-relationships",
    "content": "¥The test task will only run after the lint and build tasks have completed in the same package."
  }, {
    "heading": "任意任务关系-arbitrary-task-relationships",
    "content": "¥Arbitrary task relationships"
  }, {
    "heading": "任意任务关系-arbitrary-task-relationships",
    "content": "指定特定软件包任务之间的任务依赖。"
  }, {
    "heading": "任意任务关系-arbitrary-task-relationships",
    "content": "¥Specify a task dependency between specific package tasks."
  }, {
    "heading": "任意任务关系-arbitrary-task-relationships",
    "content": "在此 turbo.json 中，web#lint 任务将等待 utils#build 任务完成。"
  }, {
    "heading": "任意任务关系-arbitrary-task-relationships",
    "content": "¥In this turbo.json, the web#lint task will wait for the utils#build task to complete."
  }, {
    "heading": "env-env",
    "content": "任务所依赖的环境变量列表。"
  }, {
    "heading": "env-env",
    "content": "¥The list of environment variables a task depends on."
  }, {
    "heading": "env-env",
    "content": "Turborepo 会自动通过 框架推断 包含以常用框架为前缀的环境变量。例如，如果你的包是一个 Next.js 项目，则无需指定任何与 从 NEXT_PUBLIC_ 开始 相关的环境变量。"
  }, {
    "heading": "env-env",
    "content": "¥Turborepo automatically includes environment variables prefixed by common\nframeworks through Framework\nInference.\nFor example, if your package is a Next.js project, you do not need to specify\nany environment variables that start with\nNEXT_PUBLIC_."
  }, {
    "heading": "通配符-wildcards",
    "content": "¥Wildcards"
  }, {
    "heading": "通配符-wildcards",
    "content": "Turborepo 支持环境变量的通配符，因此你可以轻松地使用给定前缀来解释所有环境变量。例如，下面的 turbo.json 将所有以 MY_API_ 开头的环境变量都包含在哈希值中："
  }, {
    "heading": "通配符-wildcards",
    "content": "¥Turborepo supports wildcards for environment variables so you can easily account for all environment variables with a given prefix. For example, the turbo.json below include all environment variables that start with MY_API_ into the hash:"
  }, {
    "heading": "否决-negation",
    "content": "¥Negation"
  }, {
    "heading": "否决-negation",
    "content": "以 ! 开头表示整个模式将被否定。例如，下面的 turbo.json 将忽略 MY_API_URL 变量。"
  }, {
    "heading": "否决-negation",
    "content": "¥A leading ! means that the entire pattern will be negated. For instance, the turbo.json below will ignore the MY_API_URL variable."
  }, {
    "heading": "示例-examples",
    "content": "¥Examples"
  }, {
    "heading": "示例-examples",
    "content": "模式"
  }, {
    "heading": "示例-examples",
    "content": "描述"
  }, {
    "heading": "示例-examples",
    "content": "\"*\""
  }, {
    "heading": "示例-examples",
    "content": "匹配所有环境变量。"
  }, {
    "heading": "示例-examples",
    "content": "\"!*\""
  }, {
    "heading": "示例-examples",
    "content": "排除所有环境变量。"
  }, {
    "heading": "示例-examples",
    "content": "\"FOO*\""
  }, {
    "heading": "示例-examples",
    "content": "匹配名为 FOO、FOOD、FOO_FIGHTERS 等的单个环境变量"
  }, {
    "heading": "示例-examples",
    "content": "\"FOO\\*\""
  }, {
    "heading": "示例-examples",
    "content": "解析为 \"FOO*\" 并匹配 FOO、FOOD 和 FOO_FIGHTERS。"
  }, {
    "heading": "示例-examples",
    "content": "\"FOO\\\\*\""
  }, {
    "heading": "示例-examples",
    "content": "匹配名为 FOO*。"
  }, {
    "heading": "示例-examples",
    "content": "\"!FOO*\""
  }, {
    "heading": "示例-examples",
    "content": "排除所有以 FOO 开头的环境变量。"
  }, {
    "heading": "示例-examples",
    "content": "\"\\!FOO\""
  }, {
    "heading": "示例-examples",
    "content": "解析为 \"!FOO\"，并排除名为 !FOO 的单个环境变量。"
  }, {
    "heading": "示例-examples",
    "content": "\"\\\\!FOO\""
  }, {
    "heading": "示例-examples",
    "content": "匹配名为 !FOO。"
  }, {
    "heading": "示例-examples",
    "content": "\"FOO!\""
  }, {
    "heading": "示例-examples",
    "content": "匹配名为 FOO!。"
  }, {
    "heading": "passthroughenv-passthroughenv",
    "content": "一个环境变量的允许列表，即使在 严格环境模式 模式下，也应该在此任务的运行时可用。"
  }, {
    "heading": "passthroughenv-passthroughenv",
    "content": "¥An allowlist of environment variables that should be made available to this task's runtime, even when in Strict Environment Mode."
  }, {
    "heading": "passthroughenv-passthroughenv",
    "content": "passThroughEnv 中提供的值不计入任务的缓存键。如果你希望更改这些变量以导致缓存未命中，则需要将它们包含在 env 或 globalEnv 中。"
  }, {
    "heading": "passthroughenv-passthroughenv",
    "content": "¥Values provided in passThroughEnv do not contribute to the cache key for the\ntask. If you'd like changes to these variables to cause cache misses, you will\nneed to include them in env or globalEnv."
  }, {
    "heading": "outputs-outputs",
    "content": "与包的 package.json 相关的文件通配符模式列表，用于在任务成功完成后进行缓存。"
  }, {
    "heading": "outputs-outputs",
    "content": "¥A list of file glob patterns relative to the package's package.json to cache when the task is successfully completed."
  }, {
    "heading": "outputs-outputs",
    "content": "如果输出路径需要相对于存储库根目录，请参阅 $TURBO_ROOT$。"
  }, {
    "heading": "outputs-outputs",
    "content": "¥See $TURBO_ROOT$ if output paths need to be relative to the repository root."
  }, {
    "heading": "outputs-outputs",
    "content": "省略此键或传递一个空数组将告知 turbo 不缓存任何内容（日志除外，启用缓存后日志始终会被缓存）。"
  }, {
    "heading": "outputs-outputs",
    "content": "¥Omitting this key or passing an empty array tells turbo to cache nothing (except logs, which are always cached when caching is enabled)."
  }, {
    "heading": "cache-cache",
    "content": "默认：true"
  }, {
    "heading": "cache-cache",
    "content": "¥Default: true"
  }, {
    "heading": "cache-cache",
    "content": "定义是否缓存任务输出。对于长时间运行的开发任务，将 cache 设置为 false 非常有用，可以确保任务在执行图中始终运行。"
  }, {
    "heading": "cache-cache",
    "content": "¥Defines if task outputs should be cached. Setting cache to false is useful for long-running development tasks and ensuring that a task always runs when it is in the task's execution graph."
  }, {
    "heading": "inputs-inputs",
    "content": "默认：[]，软件包中所有已签入源代码管理的文件"
  }, {
    "heading": "inputs-inputs",
    "content": "¥Default: [], all files in the package that are checked into source control"
  }, {
    "heading": "inputs-inputs",
    "content": "与包的 package.json 相关的文件通配符模式列表，用于在确定包是否已更改时考虑。以下文件始终被视为输入，即使你尝试明确忽略它们："
  }, {
    "heading": "inputs-inputs",
    "content": "¥A list of file glob patterns relative to the package's package.json to consider when determining if a package has changed. The following files are always considered inputs, even if you try to explicitly ignore them:"
  }, {
    "heading": "inputs-inputs",
    "content": "package.json"
  }, {
    "heading": "inputs-inputs",
    "content": "turbo.json"
  }, {
    "heading": "inputs-inputs",
    "content": "包管理器锁文件"
  }, {
    "heading": "inputs-inputs",
    "content": "¥Package manager lockfiles"
  }, {
    "heading": "inputs-inputs",
    "content": "访问 文件全局规范 了解有关通配符语法的更多信息。"
  }, {
    "heading": "inputs-inputs",
    "content": "¥Visit the file glob specification for more information on globbing syntax."
  }, {
    "heading": "inputs-inputs",
    "content": "使用 inputs 键将使你退出 turbo 考虑 .gitignore 的默认行为。你必须根据需要从 .gitignore 重建 glob，或者使用 $TURBO_DEFAULT$ 构建默认行为。"
  }, {
    "heading": "inputs-inputs",
    "content": "¥Using the inputs key opts you out of turbo's default behavior of\nconsidering .gitignore. You must reconstruct the globs from .gitignore as\ndesired or use $TURBO_DEFAULT$ to build off of the default behavior."
  }, {
    "heading": "turbo_default-turbodefault",
    "content": "由于指定 inputs 键会立即退出默认行为，因此你可以在 inputs 数组中使用特殊字符串 $TURBO_DEFAULT$ 来恢复 turbo 的默认行为。这允许你调整默认行为以获得更精细的粒度。"
  }, {
    "heading": "turbo_default-turbodefault",
    "content": "¥Because specifying an inputs key immediately opts out of the default behavior, you may use\nthe special string $TURBO_DEFAULT$ within the inputs array to restore turbo's default behavior. This allows you to tweak the default behavior for more granularity."
  }, {
    "heading": "turbo_root-turboroot",
    "content": "任务可能会引用其目录之外的文件。"
  }, {
    "heading": "turbo_root-turboroot",
    "content": "¥Tasks might reference a file that lies outside of their directory."
  }, {
    "heading": "turbo_root-turboroot",
    "content": "使用 $TURBO_ROOT$ 启动文件 glob 会将 glob 更改为相对于仓库根目录，而不是包目录。"
  }, {
    "heading": "turbo_root-turboroot",
    "content": "¥Starting a file glob with $TURBO_ROOT$ will change the glob to be relative to the root of the repository instead of the package directory."
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "使用 软件包配置 时，数组字段默认会完全替换根 turbo.json 中的值。$TURBO_EXTENDS$ 微语法将此行为更改为追加而非替换。"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "¥When using Package Configurations, array fields completely replace the values from the root turbo.json by default. The $TURBO_EXTENDS$ microsyntax changes this behavior to append instead of replace."
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "此微语法可用于以下数组字段："
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "¥This microsyntax can be used in the following array fields:"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "dependsOn"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "env"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "inputs"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "outputs"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "passThroughEnv"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "with"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "例如，如果你的根 turbo.json 定义了："
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "¥For example, if your root turbo.json defines:"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "包配置可以在保留根输出的同时添加额外的输出："
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "¥A Package Configuration can add additional outputs while keeping the root outputs:"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "如果没有 $TURBO_EXTENDS$，outputs 数组将被 [\".next/**\", \"!.next/cache/**\"] 完全替换，根配置中的 \"dist/**\" 将被删除。"
  }, {
    "heading": "turbo_extends-turboextends",
    "content": "¥Without $TURBO_EXTENDS$, the outputs array would be completely replaced with [\".next/**\", \"!.next/cache/**\"], dropping the \"dist/**\" from the root configuration."
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "默认：full"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "¥Default: full"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "设置输出日志详细程度。可以被 --output-logs CLI 选项覆盖。"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "¥Set output logging verbosity. Can be overridden by the --output-logs CLI option."
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "选项"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "描述"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "full"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "显示所有日志"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "hash-only"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "仅显示任务的哈希值"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "new-only"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "仅显示缓存未命中的日志"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "errors-only"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "仅显示任务失败的日志"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "none"
  }, {
    "heading": "outputlogs-outputlogs",
    "content": "隐藏所有任务日志"
  }, {
    "heading": "persistent-persistent",
    "content": "默认：false"
  }, {
    "heading": "persistent-persistent",
    "content": "¥Default: false"
  }, {
    "heading": "persistent-persistent",
    "content": "将任务标记为 persistent，以防止其他任务依赖于长时间运行的进程。持久任务默认为 interactive。"
  }, {
    "heading": "persistent-persistent",
    "content": "¥Label a task as persistent to prevent other tasks from depending on long-running processes. Persistent tasks are made interactive by default."
  }, {
    "heading": "persistent-persistent",
    "content": "由于长时间运行的进程不会退出，因此依赖于它的任务将永远不会运行。将任务标记为持久任务后，如果其他任务依赖于该任务，turbo 将会抛出错误。"
  }, {
    "heading": "persistent-persistent",
    "content": "¥Because a long-running process won't exit, tasks that would depend on it would never run. Once you've labeled the task as persistent, turbo will throw an error if other tasks depend on it."
  }, {
    "heading": "persistent-persistent",
    "content": "此选项对于开发服务器或其他 \"watch\" 任务最有用。"
  }, {
    "heading": "persistent-persistent",
    "content": "¥This option is most useful for development servers or other \"watch\" tasks."
  }, {
    "heading": "persistent-persistent",
    "content": "默认情况下，标有 persistent 的任务也是 interactive。"
  }, {
    "heading": "persistent-persistent",
    "content": "¥Tasks marked with persistent are also interactive by default."
  }, {
    "heading": "interactive-interactive",
    "content": "默认：false（对于标记为 persistent 的任务，默认为 true）"
  }, {
    "heading": "interactive-interactive",
    "content": "¥Default: false (Defaults to true for tasks marked as persistent)"
  }, {
    "heading": "interactive-interactive",
    "content": "将任务标记为 interactive，使其在终端 UI 中接受来自 stdin 的输入。必须与 persistent 一起使用。"
  }, {
    "heading": "interactive-interactive",
    "content": "¥Label a task as interactive to make it accept inputs from stdin in the terminal UI. Must be used with persistent."
  }, {
    "heading": "interactive-interactive",
    "content": "此选项对于可以在运行时操作的脚本（例如 Jest 或 Vitest）最有用。"
  }, {
    "heading": "interactive-interactive",
    "content": "¥This option is most useful for scripts that can be manipulated while they are running, like Jest or Vitest."
  }, {
    "heading": "interruptible-interruptible",
    "content": "默认：false"
  }, {
    "heading": "interruptible-interruptible",
    "content": "¥Default: false"
  }, {
    "heading": "interruptible-interruptible",
    "content": "将 persistent 任务标记为 interruptible，以允许 turbo watch 重新启动它。"
  }, {
    "heading": "interruptible-interruptible",
    "content": "¥Label a persistent task as interruptible to allow it to be restarted by turbo watch."
  }, {
    "heading": "interruptible-interruptible",
    "content": "turbo watch 监视包的更改并自动重启受影响的任务。但是，如果任务是持久性的，则默认情况下不会重新启动。要启用重新启动持久任务，请将 interruptible 设置为 true。"
  }, {
    "heading": "interruptible-interruptible",
    "content": "¥turbo watch watches for changes to your packages and automatically restarts tasks\nthat are affected. However, if a task is persistent, it will not be restarted by default.\nTo enable restarting persistent tasks, set interruptible to true."
  }, {
    "heading": "with-with",
    "content": "将与此任务一起运行的任务列表。这对于需要确保始终同时运行的长时间运行任务非常有用。"
  }, {
    "heading": "with-with",
    "content": "¥A list of tasks that will be ran alongside this task. This is most useful for long-running tasks that you want to ensure always run at the same time."
  }, {
    "heading": "边界-boundaries",
    "content": "¥Boundaries"
  }, {
    "heading": "边界-boundaries",
    "content": "boundaries 标签允许你为 boundaries 命令 定义规则。"
  }, {
    "heading": "边界-boundaries",
    "content": "¥The boundaries tag allows you to define rules for the boundaries command."
  }, {
    "heading": "tags-tags",
    "content": "tags 对象中的每个键都是一个可以使用 turbo boundaries 检查的标签名称。"
  }, {
    "heading": "tags-tags",
    "content": "¥Each key in the tags object is the name of a tag that can be checked with turbo boundaries."
  }, {
    "heading": "tags-tags",
    "content": "在标签的配置对象中，你可以定义依赖和被依赖的规则。"
  }, {
    "heading": "tags-tags",
    "content": "¥In the configuration object for a tag, you can define rules for dependencies and dependents."
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "¥dependencies and dependents"
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "标签依赖和依赖的规则。"
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "¥Rules for a tag's dependencies and dependents."
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "你可以添加允许列表和拒绝列表："
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "¥You can add an allowlist and a denylist:"
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "允许列表和拒绝列表都可以省略。"
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "¥Both the allowlist and the denylist can be omitted."
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "还可以为标签的依赖（即导入此标签的包）添加规则。"
  }, {
    "heading": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "¥Rules can also be added for a tag's dependents, i.e. packages that import this tag."
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥Remote caching"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "全局 remoteCache 选项包含各种字段，用于配置远程缓存的使用。"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥The global remoteCache option has a variety of fields for configuring remote cache usage"
  }, {
    "heading": "enabled-enabled",
    "content": "默认：true"
  }, {
    "heading": "enabled-enabled",
    "content": "¥Default: true"
  }, {
    "heading": "enabled-enabled",
    "content": "启用远程缓存。"
  }, {
    "heading": "enabled-enabled",
    "content": "¥Enables remote caching."
  }, {
    "heading": "enabled-enabled",
    "content": "当 false 匹配时，Turborepo 将禁用所有远程缓存操作，即使仓库拥有有效的令牌。如果为 true，则启用远程缓存，但仍需要用户登录并将其代码库链接到远程缓存。"
  }, {
    "heading": "enabled-enabled",
    "content": "¥When false, Turborepo will disable all remote cache operations, even if the repo has a valid token.\nIf true, remote caching is enabled, but still requires the user to login and link their repo to a remote cache."
  }, {
    "heading": "signature-signature",
    "content": "默认：false"
  }, {
    "heading": "signature-signature",
    "content": "¥Default: false"
  }, {
    "heading": "signature-signature",
    "content": "允许对远程缓存请求进行签名验证。当 true 匹配时，Turborepo 将使用环境变量 TURBO_REMOTE_CACHE_SIGNATURE_KEY 的值对每个上传的工件进行签名。Turborepo 将拒绝任何签名无效或缺少签名的下载工件。"
  }, {
    "heading": "signature-signature",
    "content": "¥Enables signature verification for requests to the remote cache.\nWhen true, Turborepo will sign every uploaded artifact using the value of the environment variable TURBO_REMOTE_CACHE_SIGNATURE_KEY.\nTurborepo will reject any downloaded artifacts that have an invalid signature or are missing a signature."
  }, {
    "heading": "preflight-preflight",
    "content": "默认：false"
  }, {
    "heading": "preflight-preflight",
    "content": "¥Default: false"
  }, {
    "heading": "preflight-preflight",
    "content": "启用后，任何 HTTP 请求之前都会有一个 OPTIONS 请求，以确定端点是否支持该请求。"
  }, {
    "heading": "preflight-preflight",
    "content": "¥When enabled, any HTTP request will be preceded by an OPTIONS request to determine if the request is supported by the endpoint."
  }, {
    "heading": "timeout-timeout",
    "content": "默认：30"
  }, {
    "heading": "timeout-timeout",
    "content": "¥Default: 30"
  }, {
    "heading": "timeout-timeout",
    "content": "设置远程缓存操作的超时时间。值以秒为单位，并且只接受整数。如果已传递 0，则任何缓存操作均不会超时。"
  }, {
    "heading": "timeout-timeout",
    "content": "¥Sets a timeout for remote cache operations.\nValue is given in seconds and only whole values are accepted.\nIf 0 is passed, then there is no timeout for any cache operations."
  }, {
    "heading": "uploadtimeout-uploadtimeout",
    "content": "默认：60"
  }, {
    "heading": "uploadtimeout-uploadtimeout",
    "content": "¥Default: 60"
  }, {
    "heading": "uploadtimeout-uploadtimeout",
    "content": "设置远程缓存上传的超时时间。值以秒为单位，并且只接受整数。如果已传递 0，则任何远程缓存上传均不会超时。"
  }, {
    "heading": "uploadtimeout-uploadtimeout",
    "content": "¥Sets a timeout for remote cache uploads.\nValue is given in seconds and only whole values are accepted.\nIf 0 is passed, then there is no timeout for any remote cache uploads."
  }, {
    "heading": "apiurl-apiurl",
    "content": "默认：\"https://vercel.com\""
  }, {
    "heading": "apiurl-apiurl",
    "content": "¥Default: \"https://vercel.com\""
  }, {
    "heading": "apiurl-apiurl",
    "content": "设置远程缓存 API 调用的端点。"
  }, {
    "heading": "apiurl-apiurl",
    "content": "¥Set endpoint for API calls to the remote cache."
  }, {
    "heading": "loginurl-loginurl",
    "content": "默认：\"https://vercel.com\""
  }, {
    "heading": "loginurl-loginurl",
    "content": "¥Default: \"https://vercel.com\""
  }, {
    "heading": "loginurl-loginurl",
    "content": "设置在 turbo login 期间请求令牌的端点。"
  }, {
    "heading": "loginurl-loginurl",
    "content": "¥Set endpoint for requesting tokens during turbo login."
  }, {
    "heading": "teamid-teamid",
    "content": "远程缓存团队的 ID。值将作为 teamId 在所有远程缓存 HTTP 调用的查询字符串中传递。必须以 team_ 开头，否则将无法使用。"
  }, {
    "heading": "teamid-teamid",
    "content": "¥The ID of the Remote Cache team.\nValue will be passed as teamId in the querystring for all Remote Cache HTTP calls.\nMust start with team_ or it will not be used."
  }, {
    "heading": "teamslug-teamslug",
    "content": "远程缓存团队的 slug。值将作为 slug 在所有远程缓存 HTTP 调用的查询字符串中传递。"
  }, {
    "heading": "teamslug-teamslug",
    "content": "¥The slug of the Remote Cache team.\nValue will be passed as slug in the querystring for all Remote Cache HTTP calls."
  }],
  "headings": [{
    "id": "全局选项-global-options",
    "content": "全局选项 /*global-options*/"
  }, {
    "id": "extends-extends",
    "content": "extends /*extends*/"
  }, {
    "id": "globaldependencies-globaldependencies",
    "content": "globalDependencies /*globaldependencies*/"
  }, {
    "id": "globalenv-globalenv",
    "content": "globalEnv /*globalenv*/"
  }, {
    "id": "globalpassthroughenv-globalpassthroughenv",
    "content": "globalPassThroughEnv /*globalpassthroughenv*/"
  }, {
    "id": "ui-ui",
    "content": "ui /*ui*/"
  }, {
    "id": "noupdatenotifier-noupdatenotifier",
    "content": "noUpdateNotifier /*noupdatenotifier*/"
  }, {
    "id": "concurrency-concurrency",
    "content": "concurrency /*concurrency*/"
  }, {
    "id": "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
    "content": "dangerouslyDisablePackageManagerCheck /*dangerouslydisablepackagemanagercheck*/"
  }, {
    "id": "cachedir-cachedir",
    "content": "cacheDir /*cachedir*/"
  }, {
    "id": "daemon-daemon",
    "content": "daemon /*daemon*/"
  }, {
    "id": "envmode-envmode",
    "content": "envMode /*envmode*/"
  }, {
    "id": "futureflags-futureflags",
    "content": "futureFlags /*futureflags*/"
  }, {
    "id": "tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "tags Experimental /*tags-experimentalbadgeexperimentalexperimentalbadge*/"
  }, {
    "id": "定义任务-defining-tasks",
    "content": "定义任务 /*defining-tasks*/"
  }, {
    "id": "tasks-tasks",
    "content": "tasks /*tasks*/"
  }, {
    "id": "任务选项-task-options",
    "content": "任务选项 /*task-options*/"
  }, {
    "id": "extends任务级别-extends-task-level",
    "content": "extends（任务级别） /*extends-task-level*/"
  }, {
    "id": "dependson-dependson",
    "content": "dependsOn /*dependson*/"
  }, {
    "id": "依赖-dependency-relationships",
    "content": "依赖 /*dependency-relationships*/"
  }, {
    "id": "相同的包关系-same-package-relationships",
    "content": "相同的包关系 /*same-package-relationships*/"
  }, {
    "id": "任意任务关系-arbitrary-task-relationships",
    "content": "任意任务关系 /*arbitrary-task-relationships*/"
  }, {
    "id": "env-env",
    "content": "env /*env*/"
  }, {
    "id": "通配符-wildcards",
    "content": "通配符 /*wildcards*/"
  }, {
    "id": "否决-negation",
    "content": "否决 /*negation*/"
  }, {
    "id": "示例-examples",
    "content": "示例 /*examples*/"
  }, {
    "id": "passthroughenv-passthroughenv",
    "content": "passThroughEnv /*passthroughenv*/"
  }, {
    "id": "outputs-outputs",
    "content": "outputs /*outputs*/"
  }, {
    "id": "cache-cache",
    "content": "cache /*cache*/"
  }, {
    "id": "inputs-inputs",
    "content": "inputs /*inputs*/"
  }, {
    "id": "turbo_default-turbodefault",
    "content": "$TURBO_DEFAULT$ /*turbodefault*/"
  }, {
    "id": "turbo_root-turboroot",
    "content": "$TURBO_ROOT$ /*turboroot*/"
  }, {
    "id": "turbo_extends-turboextends",
    "content": "$TURBO_EXTENDS$ /*turboextends*/"
  }, {
    "id": "outputlogs-outputlogs",
    "content": "outputLogs /*outputlogs*/"
  }, {
    "id": "persistent-persistent",
    "content": "persistent /*persistent*/"
  }, {
    "id": "interactive-interactive",
    "content": "interactive /*interactive*/"
  }, {
    "id": "interruptible-interruptible",
    "content": "interruptible /*interruptible*/"
  }, {
    "id": "with-with",
    "content": "with /*with*/"
  }, {
    "id": "边界-boundaries",
    "content": "边界 /*boundaries*/"
  }, {
    "id": "tags-tags",
    "content": "tags /*tags*/"
  }, {
    "id": "dependencies-和-dependents-dependencies-and-dependents",
    "content": "dependencies 和 dependents /*dependencies-and-dependents*/"
  }, {
    "id": "远程缓存-remote-caching",
    "content": "远程缓存 /*remote-caching*/"
  }, {
    "id": "enabled-enabled",
    "content": "enabled /*enabled*/"
  }, {
    "id": "signature-signature",
    "content": "signature /*signature*/"
  }, {
    "id": "preflight-preflight",
    "content": "preflight /*preflight*/"
  }, {
    "id": "timeout-timeout",
    "content": "timeout /*timeout*/"
  }, {
    "id": "uploadtimeout-uploadtimeout",
    "content": "uploadTimeout /*uploadtimeout*/"
  }, {
    "id": "apiurl-apiurl",
    "content": "apiUrl /*apiurl*/"
  }, {
    "id": "loginurl-loginurl",
    "content": "loginUrl /*loginurl*/"
  }, {
    "id": "teamid-teamid",
    "content": "teamId /*teamid*/"
  }, {
    "id": "teamslug-teamslug",
    "content": "teamSlug /*teamslug*/"
  }]
};
import {Callout} from '#components/callout';
import {InVersion} from '#components/in-version';
import {ExperimentalBadge} from '#components/experimental-badge';
import Link from 'next/link';
export const toc = [{
  depth: 2,
  url: "#全局选项-global-options",
  title: _jsx(_Fragment, {
    children: "全局选项 "
  })
}, {
  depth: 3,
  url: "#extends-extends",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "extends"
    }), " "]
  })
}, {
  depth: 3,
  url: "#globaldependencies-globaldependencies",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "globalDependencies"
    }), " "]
  })
}, {
  depth: 3,
  url: "#globalenv-globalenv",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "globalEnv"
    }), " "]
  })
}, {
  depth: 3,
  url: "#globalpassthroughenv-globalpassthroughenv",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "globalPassThroughEnv"
    }), " "]
  })
}, {
  depth: 3,
  url: "#ui-ui",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "ui"
    }), " "]
  })
}, {
  depth: 3,
  url: "#noupdatenotifier-noupdatenotifier",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "noUpdateNotifier"
    }), " "]
  })
}, {
  depth: 3,
  url: "#concurrency-concurrency",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "concurrency"
    }), " "]
  })
}, {
  depth: 3,
  url: "#dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "dangerouslyDisablePackageManagerCheck"
    }), " "]
  })
}, {
  depth: 3,
  url: "#cachedir-cachedir",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "cacheDir"
    }), " "]
  })
}, {
  depth: 3,
  url: "#daemon-daemon",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "daemon"
    }), " "]
  })
}, {
  depth: 3,
  url: "#envmode-envmode",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "envMode"
    }), " "]
  })
}, {
  depth: 3,
  url: "#futureflags-futureflags",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "futureFlags"
    }), " "]
  })
}, {
  depth: 3,
  url: "#tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "tags"
    }), " ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    }), " "]
  })
}, {
  depth: 2,
  url: "#定义任务-defining-tasks",
  title: _jsx(_Fragment, {
    children: "定义任务 "
  })
}, {
  depth: 3,
  url: "#tasks-tasks",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "tasks"
    }), " "]
  })
}, {
  depth: 2,
  url: "#任务选项-task-options",
  title: _jsx(_Fragment, {
    children: "任务选项 "
  })
}, {
  depth: 3,
  url: "#extends任务级别-extends-task-level",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "extends"
    }), "（任务级别） "]
  })
}, {
  depth: 3,
  url: "#dependson-dependson",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "dependsOn"
    }), " "]
  })
}, {
  depth: 4,
  url: "#依赖-dependency-relationships",
  title: _jsx(_Fragment, {
    children: "依赖 "
  })
}, {
  depth: 4,
  url: "#相同的包关系-same-package-relationships",
  title: _jsx(_Fragment, {
    children: "相同的包关系 "
  })
}, {
  depth: 4,
  url: "#任意任务关系-arbitrary-task-relationships",
  title: _jsx(_Fragment, {
    children: "任意任务关系 "
  })
}, {
  depth: 3,
  url: "#env-env",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "env"
    }), " "]
  })
}, {
  depth: 4,
  url: "#通配符-wildcards",
  title: _jsx(_Fragment, {
    children: "通配符 "
  })
}, {
  depth: 4,
  url: "#否决-negation",
  title: _jsx(_Fragment, {
    children: "否决 "
  })
}, {
  depth: 4,
  url: "#示例-examples",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 3,
  url: "#passthroughenv-passthroughenv",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "passThroughEnv"
    }), " "]
  })
}, {
  depth: 3,
  url: "#outputs-outputs",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "outputs"
    }), " "]
  })
}, {
  depth: 3,
  url: "#cache-cache",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "cache"
    }), " "]
  })
}, {
  depth: 3,
  url: "#inputs-inputs",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "inputs"
    }), " "]
  })
}, {
  depth: 4,
  url: "#turbo_default-turbodefault",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "$TURBO_DEFAULT$"
    }), " "]
  })
}, {
  depth: 4,
  url: "#turbo_root-turboroot",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "$TURBO_ROOT$"
    }), " "]
  })
}, {
  depth: 4,
  url: "#turbo_extends-turboextends",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "$TURBO_EXTENDS$"
    }), " "]
  })
}, {
  depth: 3,
  url: "#outputlogs-outputlogs",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "outputLogs"
    }), " "]
  })
}, {
  depth: 3,
  url: "#persistent-persistent",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "persistent"
    }), " "]
  })
}, {
  depth: 3,
  url: "#interactive-interactive",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "interactive"
    }), " "]
  })
}, {
  depth: 3,
  url: "#interruptible-interruptible",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "interruptible"
    }), " "]
  })
}, {
  depth: 3,
  url: "#with-with",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "with"
    }), " "]
  })
}, {
  depth: 2,
  url: "#边界-boundaries",
  title: _jsx(_Fragment, {
    children: "边界 "
  })
}, {
  depth: 3,
  url: "#tags-tags",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "tags"
    }), " "]
  })
}, {
  depth: 4,
  url: "#dependencies-和-dependents-dependencies-and-dependents",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "dependencies"
    }), " 和 ", _jsx("code", {
      children: "dependents"
    }), " "]
  })
}, {
  depth: 2,
  url: "#远程缓存-remote-caching",
  title: _jsx(_Fragment, {
    children: "远程缓存 "
  })
}, {
  depth: 3,
  url: "#enabled-enabled",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "enabled"
    }), " "]
  })
}, {
  depth: 3,
  url: "#signature-signature",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "signature"
    }), " "]
  })
}, {
  depth: 3,
  url: "#preflight-preflight",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "preflight"
    }), " "]
  })
}, {
  depth: 3,
  url: "#timeout-timeout",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "timeout"
    }), " "]
  })
}, {
  depth: 3,
  url: "#uploadtimeout-uploadtimeout",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "uploadTimeout"
    }), " "]
  })
}, {
  depth: 3,
  url: "#apiurl-apiurl",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "apiUrl"
    }), " "]
  })
}, {
  depth: 3,
  url: "#loginurl-loginurl",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "loginUrl"
    }), " "]
  })
}, {
  depth: 3,
  url: "#teamid-teamid",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "teamId"
    }), " "]
  })
}, {
  depth: 3,
  url: "#teamslug-teamslug",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "teamSlug"
    }), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["使用工作区根目录中的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件配置 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的行为。你还可以："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Configure the behavior of ", _jsx(_components.code, {
        children: "turbo"
      }), " by using a ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file in your Workspace's root directory. You can also:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.a, {
            href: "/docs/reference/package-configurations",
            children: "软件包配置"
          }), " 进行更精细的控制。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.a, {
            href: "/docs/reference/package-configurations",
            children: "Package Configurations"
          }), " for more granular control."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "turbo.jsonc"
          }), " 为你的配置添加注释，并借助 IDE 支持。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.code, {
            children: "turbo.jsonc"
          }), " to add comments to your configuration with IDE support."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "全局选项-global-options",
      children: "全局选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Global options"
    }), "\n", _jsxs(_components.h3, {
      id: "extends-extends",
      children: [_jsx(_components.code, {
        children: "extends"
      }), " "]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["从根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 扩展，使用 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "软件包配置"
      }), " 为包创建特定配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Extend from the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " to create specific configuration for a package using ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configurations"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["要从根包的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 继承配置，", _jsx(_components.code, {
            children: "extends"
          }), " 数组必须以 ", _jsx(_components.code, {
            children: "[\"//\"]"
          }), " 开头。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "extends"
          }), " array must start with ", _jsx(_components.code, {
            children: "[\"//\"]"
          }), " to inherit configuration from the root ", _jsx(_components.code, {
            children: "turbo.json"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你还可以从其他包（例如 ", _jsx(_components.code, {
            children: "[\"//\", \"shared-config\"]"
          }), "）扩展。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You can also extend from other packages (e.g., ", _jsx(_components.code, {
            children: "[\"//\", \"shared-config\"]"
          }), ")."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果在根 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中使用 ", _jsx(_components.code, {
            children: "extends"
          }), "，它将被忽略。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If ", _jsx(_components.code, {
            children: "extends"
          }), " is used in the root ", _jsx(_components.code, {
            children: "turbo.json"
          }), ", it will be ignored."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.h3, {
      id: "globaldependencies-globaldependencies",
      children: [_jsx(_components.code, {
        children: "globalDependencies"
      }), " "]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsconfig.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["要包含在所有任务哈希中的全局变量列表。如果任何与这些全局变量匹配的文件发生更改，所有任务都将丢失缓存。Globs 是相对于 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 位置的。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A list of globs that you want to include in all task hashes. ", _jsx(_components.strong, {
        children: "If any file matching these globs changes, all tasks will miss cache."
      }), " Globs are relative to the location of ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "全局哈希"
      }), " 仅包含根 package.json 和 lockfile，并且不能忽略。任何添加的 ", _jsx(_components.code, {
        children: "globalDependencies"
      }), " 也将包含在全局哈希中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By default, only the root package.json and lockfile are included in ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "the global hash"
      }), " and can't be ignored. Any added ", _jsx(_components.code, {
        children: "globalDependencies"
      }), " will also be included in the global hash."]
    }), "\n", _jsxs(Callout, {
      type: "error",
      children: [_jsx(_components.p, {
        children: "Globs 必须位于仓库的源代码控制根目录。不支持仓库外的 Glob。"
      }), _jsx(_components.p, {
        children: "¥Globs must be in the repository's source control root. Globs outside of the\nrepository aren't supported."
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "globalenv-globalenv",
      children: [_jsx(_components.code, {
        children: "globalEnv"
      }), " "]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"GITHUB_TOKEN\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"PACKAGE_VERSION\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"NODE_ENV\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "你希望影响所有任务哈希值的环境变量列表。对这些环境变量的任何更改都会导致所有任务缓存未命中。"
    }), "\n", _jsx(_components.p, {
      children: "¥A list of environment variables that you want to impact the hash of all tasks. Any change to these environment variables will cause all tasks to miss cache."
    }), "\n", _jsxs(_components.p, {
      children: ["关于通配符和否定语法的更多信息，请参阅 ", _jsxs(_components.a, {
        href: "#env",
        children: ["参见 ", _jsx(_components.code, {
          children: "env"
        }), " 部分"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more on wildcard and negation syntax, ", _jsxs(_components.a, {
        href: "#env",
        children: ["see the ", _jsx(_components.code, {
          children: "env"
        }), " section"]
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "globalpassthroughenv-globalpassthroughenv",
      children: [_jsx(_components.code, {
        children: "globalPassThroughEnv"
      }), " "]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalPassThroughEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"AWS_SECRET_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"GITHUB_TOKEN\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["你希望对任务可用的环境变量列表。使用此键会将所有任务添加到 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#strict-mode",
        children: "严格环境变量模式"
      }), " 中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A list of environment variables that you want to make available to tasks. Using this key opts all tasks into ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#strict-mode",
        children: "Strict Environment Variable Mode"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["此外，Turborepo 内置了一组全局传递变量，用于常见情况，例如操作系统环境变量。这包括 ", _jsx(_components.code, {
        children: "HOME"
      }), "、", _jsx(_components.code, {
        children: "PATH"
      }), "、", _jsx(_components.code, {
        children: "APPDATA"
      }), "、", _jsx(_components.code, {
        children: "SHELL"
      }), "、", _jsx(_components.code, {
        children: "PWD"
      }), " 等变量。完整列表可在 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/crates/turborepo-lib/src/task_hash.rs",
        children: "在源代码中"
      }), " 中找到。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, Turborepo has a built-in set of global passthrough variables for common cases, like operating system environment variables. This includes variables like ", _jsx(_components.code, {
        children: "HOME"
      }), ", ", _jsx(_components.code, {
        children: "PATH"
      }), ", ", _jsx(_components.code, {
        children: "APPDATA"
      }), ", ", _jsx(_components.code, {
        children: "SHELL"
      }), ", ", _jsx(_components.code, {
        children: "PWD"
      }), ", and more. The full list can be found ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/crates/turborepo-lib/src/task_hash.rs",
        children: "in the source code"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      title: "Passthrough values do not contribute to hashes for caching",
      children: [_jsxs(_components.p, {
        children: ["如果你希望这些变量的更改导致缓存未命中，则需要将它们包含在 ", _jsx(_components.a, {
          href: "#env",
          children: _jsx(_components.code, {
            children: "env"
          })
        }), " 或 ", _jsx(_components.a, {
          href: "#globalenv",
          children: _jsx(_components.code, {
            children: "globalEnv"
          })
        }), " 中。"]
      }), _jsxs(_components.p, {
        children: ["¥If you want changes in these variables to cause cache misses, you will need to\ninclude them in ", _jsx(_components.a, {
          href: "#env",
          children: _jsx(_components.code, {
            children: "env"
          })
        }), " or ", _jsx(_components.a, {
          href: "#globalenv",
          children: _jsx(_components.code, {
            children: "globalEnv"
          })
        }), "."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "ui-ui",
      children: [_jsx(_components.code, {
        children: "ui"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "\"stream\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "\"stream\""
      })]
    }), "\n", _jsx(_components.p, {
      children: "为存储库选择一个终端 UI。"
    }), "\n", _jsx(_components.p, {
      children: "¥Select a terminal UI for the repository."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "\"tui\""
      }), " 允许一次性查看每个日志并与任务交互。", _jsx(_components.code, {
        children: "\"stream\""
      }), " 会在日志输入时输出日志，并且不可交互。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "\"tui\""
      }), " allows for viewing each log at once and interacting with the task. ", _jsx(_components.code, {
        children: "\"stream\""
      }), " outputs logs as they come in and is not interactive."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " | "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"stream\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "noupdatenotifier-noupdatenotifier",
      children: [_jsx(_components.code, {
        children: "noUpdateNotifier"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置为 ", _jsx(_components.code, {
        children: "true"
      }), " 时，将禁用 ", _jsx(_components.code, {
        children: "turbo"
      }), " 新版本可用时显示的更新通知。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When set to ", _jsx(_components.code, {
        children: "true"
      }), ", disables the update notification that appears when a new version of ", _jsx(_components.code, {
        children: "turbo"
      }), " is available."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"noUpdateNotifier\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "concurrency-concurrency",
      children: [_jsx(_components.code, {
        children: "concurrency"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "\"10\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "\"10\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置/限制任务执行的最大并发数。必须是大于或等于 ", _jsx(_components.code, {
        children: "1"
      }), " 的整数，或者像 ", _jsx(_components.code, {
        children: "50%"
      }), " 这样的百分比值。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Set/limit the maximum concurrency for task execution. Must be an integer greater than or equal to ", _jsx(_components.code, {
        children: "1"
      }), " or a percentage value like ", _jsx(_components.code, {
        children: "50%"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "1"
          }), " 强制串行执行（一次执行一个任务）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.code, {
            children: "1"
          }), " to force serial execution (one task at a time)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "100%"
          }), " 使用所有可用的逻辑处理器。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Use ", _jsx(_components.code, {
            children: "100%"
          }), " to use all available logical processors."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果同时传递了 ", _jsx(_components.a, {
            href: "/docs/reference/run#--parallel",
            children: _jsx(_components.code, {
              children: "--parallel"
            })
          }), " 标志，则此选项将被忽略。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥This option is ignored if the ", _jsx(_components.a, {
            href: "/docs/reference/run#--parallel",
            children: _jsx(_components.code, {
              children: "--parallel"
            })
          }), " flag is also passed."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"concurrency\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"1\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "dangerouslydisablepackagemanagercheck-dangerouslydisablepackagemanagercheck",
      children: [_jsx(_components.code, {
        children: "dangerouslyDisablePackageManagerCheck"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 使用你仓库的锁文件来确定缓存行为、", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages",
        children: "软件包图表"
      }), " 等。因此，我们使用 ", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#packagemanager",
        children: [_jsx(_components.code, {
          children: "packageManager"
        }), " 字段"]
      }), " 来帮助你稳定 Turborepo。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo uses your repository's lockfile to determine caching behavior, ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages",
        children: "Package Graphs"
      }), ", and more. Because of this, we use ", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#packagemanager",
        children: ["the ", _jsx(_components.code, {
          children: "packageManager"
        }), " field"]
      }), " to help you stabilize your Turborepo."]
    }), "\n", _jsxs(_components.p, {
      children: ["为了帮助增量迁移或在无法使用 ", _jsx(_components.code, {
        children: "packageManager"
      }), " 字段的情况下，你可以使用 ", _jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      }), " 退出此检查，并承担不稳定的锁文件产生不可预测行为的风险。禁用后，Turborepo 将尽力查找适用于该存储库的包管理器。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To help with incremental migration or in situations where you can't use the ", _jsx(_components.code, {
        children: "packageManager"
      }), " field, you may use ", _jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      }), " to opt out of this check and assume the risks of unstable lockfiles producing unpredictable behavior. When disabled, Turborepo will attempt a best-effort discovery of the intended package manager meant for the repository."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"dangerouslyDisablePackageManagerCheck\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["你也可以通过 ", _jsx(_components.a, {
          href: "/docs/reference/run#--dangerously-disable-package-manager-check",
          children: _jsx(_components.code, {
            children: "flag"
          })
        }), " 或 ", _jsx(_components.a, {
          href: "https://turbo.nodejs.cn/docs/reference/system-environment-variables",
          children: _jsx(_components.code, {
            children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
          })
        }), " 环境变量选择退出此检查。"]
      }), _jsxs(_components.p, {
        children: ["¥You may also opt out of this check via\n", _jsx(_components.a, {
          href: "/docs/reference/run#--dangerously-disable-package-manager-check",
          children: _jsx(_components.code, {
            children: "flag"
          })
        }), " or\nthe\n", _jsx(_components.a, {
          href: "https://turbo.nodejs.cn/docs/reference/system-environment-variables",
          children: _jsx(_components.code, {
            children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
          })
        }), "\nenvironment variable."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "cachedir-cachedir",
      children: [_jsx(_components.code, {
        children: "cacheDir"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "\".turbo/cache\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "\".turbo/cache\""
      })]
    }), "\n", _jsx(_components.p, {
      children: "指定文件系统缓存目录。"
    }), "\n", _jsx(_components.p, {
      children: "¥Specify the filesystem cache directory."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"cacheDir\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".turbo/cache\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "daemon-daemon",
      children: [_jsx(_components.code, {
        children: "daemon"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 会运行后台进程来预先计算一些开销很大的操作。此独立进程（守护进程）是一种性能优化，并非 ", _jsx(_components.code, {
        children: "turbo"
      }), " 正常运行所必需的。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo runs a background process to pre-calculate some expensive operations. This standalone process (daemon) is a performance optimization, and not required for proper functioning of ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"daemon\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.p, {
        children: "在 CI 环境中运行时，无论此设置如何，守护进程始终处于禁用状态。"
      }), _jsx(_components.p, {
        children: "¥When running in a CI environment the daemon is always disabled regardless of\nthis setting."
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "envmode-envmode",
      children: [_jsx(_components.code, {
        children: "envMode"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "\"strict\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "\"strict\""
      })]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 的环境模式允许你控制在运行时哪些环境变量可用于任务："
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo's Environment Modes allow you to control which environment variables are available to a task at runtime:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "\"strict\""
          }), "：将环境变量过滤为仅在 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中的 ", _jsx(_components.code, {
            children: "env"
          }), " 和 ", _jsx(_components.code, {
            children: "globalEnv"
          }), " 键中指定的变量。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "\"strict\""
          }), ": Filter environment variables to only those that are specified in the ", _jsx(_components.code, {
            children: "env"
          }), " and ", _jsx(_components.code, {
            children: "globalEnv"
          }), " keys in ", _jsx(_components.code, {
            children: "turbo.json"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "\"loose\""
          }), "：允许进程的所有环境变量可用。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "\"loose\""
          }), ": Allow all environment variables for the process to be available."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"envMode\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"strict\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["了解更多关于 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#environment-modes",
        children: "环境模式"
      }), " 的信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Read more about ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#environment-modes",
        children: "Environment Modes"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "futureflags-futureflags",
      children: [_jsx(_components.code, {
        children: "futureFlags"
      }), " "]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"futureFlags\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "启用将在 Turborepo 的未来版本中成为默认行为的实验性功能。"
    }), "\n", _jsx(_components.p, {
      children: "¥Enable experimental features that will become the default behavior in future versions of Turborepo."
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "futureFlags"
        }), " 只能在根 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 中设置。如果在 ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "软件包配置"
        }), " 中设置，将会抛出错误。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "futureFlags"
        }), " can only be set in the root ", _jsx(_components.code, {
          children: "turbo.json"
        }), ". An error will be\nthrown if set in a ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "Package\nConfiguration"
        }), "."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "目前没有未来标志。"
    }), "\n", _jsx(_components.p, {
      children: "¥There are no future flags at this time."
    }), "\n", _jsxs(_components.h3, {
      id: "tags-experimental-tags-experimentalbadgeexperimentalexperimentalbadge",
      children: [_jsx(_components.code, {
        children: "tags"
      }), " ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      }), " "]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tags\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"utils\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["为包添加标签以便与 ", _jsx(_components.a, {
        href: "/docs/reference/boundaries",
        children: "边界"
      }), " 一起使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Adds a tag to a package for use with ", _jsx(_components.a, {
        href: "/docs/reference/boundaries",
        children: "Boundaries"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["此键仅在 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "软件包配置"
      }), " 中有效。在根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中使用此键将导致错误。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This key only works in ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configurations"
      }), ". Using this key in a root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " will result in an error."]
    }), "\n", _jsx(_components.h2, {
      id: "定义任务-defining-tasks",
      children: "定义任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Defining tasks"
    }), "\n", _jsxs(_components.h3, {
      id: "tasks-tasks",
      children: [_jsx(_components.code, {
        children: "tasks"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tasks"
      }), " 对象中的每个键都是一个可以由 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), " 执行的任务名称。Turborepo 将在你的 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "工作区配置"
      }), " 中描述的包中搜索 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中与任务名称相同的脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Each key in the ", _jsx(_components.code, {
        children: "tasks"
      }), " object is the name of a task that can be executed by ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), ". Turborepo will search the packages described in your ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "Workspace's configuration"
      }), " for scripts in ", _jsx(_components.code, {
        children: "package.json"
      }), " with the name of the task."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用任务中描述的其余配置，Turborepo 将按照描述的顺序运行脚本，并在提供日志和文件输出时将其缓存在 ", _jsxs(_components.a, {
        href: "#outputs",
        children: [_jsx(_components.code, {
          children: "outputs"
        }), " 键"]
      }), " 中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using the rest of the configuration described in the task, Turborepo will run the scripts in the described order, caching logs and file outputs in ", _jsxs(_components.a, {
        href: "#outputs",
        children: ["the ", _jsx(_components.code, {
          children: "outputs"
        }), " key"]
      }), " when provided."]
    }), "\n", _jsxs(_components.p, {
      children: ["在下面的示例中，我们在 ", _jsx(_components.code, {
        children: "tasks"
      }), " 键下定义了三个任务：", _jsx(_components.code, {
        children: "build"
      }), "、", _jsx(_components.code, {
        children: "test"
      }), " 和 ", _jsx(_components.code, {
        children: "dev"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In the example below, we've defined three tasks under the ", _jsx(_components.code, {
        children: "tasks"
      }), " key: ", _jsx(_components.code, {
        children: "build"
      }), ", ", _jsx(_components.code, {
        children: "test"
      }), ", and ", _jsx(_components.code, {
        children: "dev"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"coverage/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "任务选项-task-options",
      children: "任务选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Task options"
    }), "\n", _jsxs(_components.p, {
      children: ["使用你在 ", _jsx(_components.code, {
        children: "tasks"
      }), " 中定义的任务中可用的选项，你可以描述 ", _jsx(_components.code, {
        children: "turbo"
      }), " 将如何运行你的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using the options available in the tasks you define in ", _jsx(_components.code, {
        children: "tasks"
      }), ", you can describe how ", _jsx(_components.code, {
        children: "turbo"
      }), " will run your tasks."]
    }), "\n", _jsxs(_components.h3, {
      id: "extends任务级别-extends-task-level",
      children: [_jsx(_components.code, {
        children: "extends"
      }), "（任务级别） "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "extends"
      }), " (task-level)"]
    }), "\n", _jsxs(_components.p, {
      children: ["控制任务是否从继承链继承配置。此选项仅在 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "软件包配置"
      }), " 中可用，在根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中不可用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Controls whether a task inherits configuration from the extends chain. This option is only available in ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configurations"
      }), ", not in the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // Exclude this task from the package"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "值"
          }), _jsx(_components.th, {
            children: "行为"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "false"
            })
          }), _jsx(_components.td, {
            children: "任务不参与继承。如果没有提供其他配置，则该任务不会存在于此包中。如果提供了其他配置，则会创建一个新的任务定义，并且不继承任何现有配置。"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "true"
            }), "（默认）"]
          }), _jsx(_components.td, {
            children: "任务通常从 extends 链继承配置。"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["有关示例和更多详细信息，请参阅 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations#excluding-tasks-from-inheritance",
        children: "从继承中排除任务"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥See ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations#excluding-tasks-from-inheritance",
        children: "Excluding tasks from inheritance"
      }), " for examples and more details."]
    }), "\n", _jsxs(_components.h3, {
      id: "dependson-dependson",
      children: [_jsx(_components.code, {
        children: "dependsOn"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "在任务开始运行之前需要完成的任务列表。"
    }), "\n", _jsx(_components.p, {
      children: "¥A list of tasks that are required to complete before the task begins running."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "dependsOn"
      }), " 关系有三种类型：", _jsx(_components.a, {
        href: "#dependency-relationships",
        children: "依赖"
      }), "、", _jsx(_components.a, {
        href: "#same-package-relationships",
        children: "同包关系"
      }), " 和 ", _jsx(_components.a, {
        href: "#arbitrary-task-relationships",
        children: "任意任务关系"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There are three types of ", _jsx(_components.code, {
        children: "dependsOn"
      }), " relationships: ", _jsx(_components.a, {
        href: "#dependency-relationships",
        children: "dependency relationships"
      }), ", ", _jsx(_components.a, {
        href: "#same-package-relationships",
        children: "same-package relationships"
      }), ", and ", _jsx(_components.a, {
        href: "#arbitrary-task-relationships",
        children: "arbitrary task relationships"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "依赖-dependency-relationships",
      children: "依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥Dependency relationships"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 中的字符串前面加上 ", _jsx(_components.code, {
        children: "^"
      }), " 前缀，告诉 ", _jsx(_components.code, {
        children: "turbo"
      }), " 该任务必须先等待包依赖中的任务完成。例如，在下面的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Prefixing a string in ", _jsx(_components.code, {
        children: "dependsOn"
      }), " with a ", _jsx(_components.code, {
        children: "^"
      }), " tells ", _jsx(_components.code, {
        children: "turbo"
      }), " that the task must wait for tasks in the package's dependencies to complete first. For example, in the ", _jsx(_components.code, {
        children: "turbo.json"
      }), " below:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 从包图的 \"bottom\" 开始，递归访问每个包，直到找到没有内部依赖的包。然后，它将首先运行依赖链末尾的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务，然后返回 \"top\" 任务，直到所有 ", _jsx(_components.code, {
        children: "build"
      }), " 任务按顺序完成。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " starts at the \"bottom\" of the package graph and recursively visits each package until it finds a package with no internal dependencies. It will then run the ", _jsx(_components.code, {
        children: "build"
      }), " task at the end of the dependency chain first, working its way back to the \"top\" until all ", _jsx(_components.code, {
        children: "build"
      }), " tasks are completed in order."]
    }), "\n", _jsx(_components.h4, {
      id: "相同的包关系-same-package-relationships",
      children: "相同的包关系 "
    }), "\n", _jsx(_components.p, {
      children: "¥Same package relationships"
    }), "\n", _jsxs(_components.p, {
      children: ["不带 ", _jsx(_components.code, {
        children: "^"
      }), " 前缀的任务名称描述依赖于同一包中其他任务的任务。例如，在下面的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Task names without the ", _jsx(_components.code, {
        children: "^"
      }), " prefix describe a task that depends on a different task within the same package. For example, in the ", _jsx(_components.code, {
        children: "turbo.json"
      }), " below:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "test"
      }), " 任务仅在 ", _jsx(_components.code, {
        children: "lint"
      }), " 和 ", _jsx(_components.code, {
        children: "build"
      }), " 任务在同一软件包中完成后才会运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "test"
      }), " task will only run after the ", _jsx(_components.code, {
        children: "lint"
      }), " and ", _jsx(_components.code, {
        children: "build"
      }), " tasks have completed ", _jsx(_components.strong, {
        children: "in the same package"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "任意任务关系-arbitrary-task-relationships",
      children: "任意任务关系 "
    }), "\n", _jsx(_components.p, {
      children: "¥Arbitrary task relationships"
    }), "\n", _jsx(_components.p, {
      children: "指定特定软件包任务之间的任务依赖。"
    }), "\n", _jsx(_components.p, {
      children: "¥Specify a task dependency between specific package tasks."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"utils#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在此 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中，", _jsx(_components.code, {
        children: "web#lint"
      }), " 任务将等待 ", _jsx(_components.code, {
        children: "utils#build"
      }), " 任务完成。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In this ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", the ", _jsx(_components.code, {
        children: "web#lint"
      }), " task will wait for the ", _jsx(_components.code, {
        children: "utils#build"
      }), " task to complete."]
    }), "\n", _jsxs(_components.h3, {
      id: "env-env",
      children: [_jsx(_components.code, {
        children: "env"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "任务所依赖的环境变量列表。"
    }), "\n", _jsx(_components.p, {
      children: "¥The list of environment variables a task depends on."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"DATABASE_URL\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Impacts hash of all build tasks"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"API_SERVICE_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Impacts hash of web's build task"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["Turborepo 会自动通过 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
          children: "框架推断"
        }), " 包含以常用框架为前缀的环境变量。例如，如果你的包是一个 Next.js 项目，则无需指定任何与 ", _jsxs(_components.a, {
          href: "https://next.nodejs.cn/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser",
          children: ["从 ", _jsx(_components.code, {
            children: "NEXT_PUBLIC_"
          }), " 开始"]
        }), " 相关的环境变量。"]
      }), _jsxs(_components.p, {
        children: ["¥Turborepo automatically includes environment variables prefixed by common\nframeworks through ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
          children: "Framework\nInference"
        }), ".\nFor example, if your package is a Next.js project, you do not need to specify\nany environment variables that ", _jsxs(_components.a, {
          href: "https://next.nodejs.cn/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser",
          children: ["start with\n", _jsx(_components.code, {
            children: "NEXT_PUBLIC_"
          })]
        }), "."]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "通配符-wildcards",
      children: "通配符 "
    }), "\n", _jsx(_components.p, {
      children: "¥Wildcards"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 支持环境变量的通配符，因此你可以轻松地使用给定前缀来解释所有环境变量。例如，下面的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 将所有以 ", _jsx(_components.code, {
        children: "MY_API_"
      }), " 开头的环境变量都包含在哈希值中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo supports wildcards for environment variables so you can easily account for all environment variables with a given prefix. For example, the ", _jsx(_components.code, {
        children: "turbo.json"
      }), " below include all environment variables that start with ", _jsx(_components.code, {
        children: "MY_API_"
      }), " into the hash:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"MY_API_*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "否决-negation",
      children: "否决 "
    }), "\n", _jsx(_components.p, {
      children: "¥Negation"
    }), "\n", _jsxs(_components.p, {
      children: ["以 ", _jsx(_components.code, {
        children: "!"
      }), " 开头表示整个模式将被否定。例如，下面的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 将忽略 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 变量。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A leading ", _jsx(_components.code, {
        children: "!"
      }), " means that the entire pattern will be negated. For instance, the ", _jsx(_components.code, {
        children: "turbo.json"
      }), " below will ignore the ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " variable."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"!MY_API_URL\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "示例-examples",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Examples"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "模式"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"*\""
            })
          }), _jsx(_components.td, {
            children: "匹配所有环境变量。"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"!*\""
            })
          }), _jsx(_components.td, {
            children: "排除所有环境变量。"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"FOO*\""
            })
          }), _jsxs(_components.td, {
            children: ["匹配名为 ", _jsx(_components.code, {
              children: "FOO"
            }), "、", _jsx(_components.code, {
              children: "FOOD"
            }), "、", _jsx(_components.code, {
              children: "FOO_FIGHTERS"
            }), " 等的单个环境变量"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"FOO\\*\""
            })
          }), _jsxs(_components.td, {
            children: ["解析为 ", _jsx(_components.code, {
              children: "\"FOO*\""
            }), " 并匹配 ", _jsx(_components.code, {
              children: "FOO"
            }), "、", _jsx(_components.code, {
              children: "FOOD"
            }), " 和 ", _jsx(_components.code, {
              children: "FOO_FIGHTERS"
            }), "。"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"FOO\\\\*\""
            })
          }), _jsxs(_components.td, {
            children: ["匹配名为 ", _jsx(_components.code, {
              children: "FOO*"
            }), "。"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"!FOO*\""
            })
          }), _jsxs(_components.td, {
            children: ["排除所有以 ", _jsx(_components.code, {
              children: "FOO"
            }), " 开头的环境变量。"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"\\!FOO\""
            })
          }), _jsxs(_components.td, {
            children: ["解析为 ", _jsx(_components.code, {
              children: "\"!FOO\""
            }), "，并排除名为 ", _jsx(_components.code, {
              children: "!FOO"
            }), " 的单个环境变量。"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"\\\\!FOO\""
            })
          }), _jsxs(_components.td, {
            children: ["匹配名为 ", _jsx(_components.code, {
              children: "!FOO"
            }), "。"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "\"FOO!\""
            })
          }), _jsxs(_components.td, {
            children: ["匹配名为 ", _jsx(_components.code, {
              children: "FOO!"
            }), "。"]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "passthroughenv-passthroughenv",
      children: [_jsx(_components.code, {
        children: "passThroughEnv"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["一个环境变量的允许列表，即使在 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#strict-mode",
        children: "严格环境模式"
      }), " 模式下，也应该在此任务的运行时可用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥An allowlist of environment variables that should be made available to this task's runtime, even when in ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#strict-mode",
        children: "Strict Environment Mode"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Values will be available within `build` scripts"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"passThroughEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"AWS_SECRET_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"GITHUB_TOKEN\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "passThroughEnv"
        }), " 中提供的值不计入任务的缓存键。如果你希望更改这些变量以导致缓存未命中，则需要将它们包含在 ", _jsx(_components.a, {
          href: "#env",
          children: _jsx(_components.code, {
            children: "env"
          })
        }), " 或 ", _jsx(_components.a, {
          href: "#globalenv",
          children: _jsx(_components.code, {
            children: "globalEnv"
          })
        }), " 中。"]
      }), _jsxs(_components.p, {
        children: ["¥Values provided in ", _jsx(_components.code, {
          children: "passThroughEnv"
        }), " do not contribute to the cache key for the\ntask. If you'd like changes to these variables to cause cache misses, you will\nneed to include them in ", _jsx(_components.a, {
          href: "#env",
          children: _jsx(_components.code, {
            children: "env"
          })
        }), " or ", _jsx(_components.a, {
          href: "#globalenv",
          children: _jsx(_components.code, {
            children: "globalEnv"
          })
        }), "."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "outputs-outputs",
      children: [_jsx(_components.code, {
        children: "outputs"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["与包的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 相关的文件通配符模式列表，用于在任务成功完成后进行缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A list of file glob patterns relative to the package's ", _jsx(_components.code, {
        children: "package.json"
      }), " to cache when the task is successfully completed."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果输出路径需要相对于存储库根目录，请参阅 ", _jsx(_components.a, {
        href: "#turbo_root",
        children: _jsx(_components.code, {
          children: "$TURBO_ROOT$"
        })
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥See ", _jsx(_components.a, {
        href: "#turbo_root",
        children: _jsx(_components.code, {
          children: "$TURBO_ROOT$"
        })
      }), " if output paths need to be relative to the repository root."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Cache all files emitted to the packages's `dist` directory"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["省略此键或传递一个空数组将告知 ", _jsx(_components.code, {
        children: "turbo"
      }), " 不缓存任何内容（日志除外，启用缓存后日志始终会被缓存）。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Omitting this key or passing an empty array tells ", _jsx(_components.code, {
        children: "turbo"
      }), " to cache nothing (except logs, which are always cached when caching is enabled)."]
    }), "\n", _jsxs(_components.h3, {
      id: "cache-cache",
      children: [_jsx(_components.code, {
        children: "cache"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["定义是否缓存任务输出。对于长时间运行的开发任务，将 ", _jsx(_components.code, {
        children: "cache"
      }), " 设置为 false 非常有用，可以确保任务在执行图中始终运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Defines if task outputs should be cached. Setting ", _jsx(_components.code, {
        children: "cache"
      }), " to false is useful for long-running development tasks and ensuring that a task always runs when it is in the task's execution graph."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".svelte-kit/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// File outputs will be cached"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // No outputs will be cached"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "inputs-inputs",
      children: [_jsx(_components.code, {
        children: "inputs"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "[]"
      }), "，软件包中所有已签入源代码管理的文件"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "[]"
      }), ", all files in the package that are checked into source control"]
    }), "\n", _jsxs(_components.p, {
      children: ["与包的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 相关的文件通配符模式列表，用于在确定包是否已更改时考虑。以下文件始终被视为输入，即使你尝试明确忽略它们："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A list of file glob patterns relative to the package's ", _jsx(_components.code, {
        children: "package.json"
      }), " to consider when determining if a package has changed. The following files are ", _jsx(_components.strong, {
        children: "always"
      }), " considered inputs, even if you try to explicitly ignore them:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "package.json"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "turbo.json"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "包管理器锁文件"
        }), "\n", _jsx(_components.p, {
          children: "¥Package manager lockfiles"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["访问 ", _jsx(_components.a, {
        href: "/docs/reference/globs",
        children: "文件全局规范"
      }), " 了解有关通配符语法的更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Visit the ", _jsx(_components.a, {
        href: "/docs/reference/globs",
        children: "file glob specification"
      }), " for more information on globbing syntax."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"src/**/*.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"src/**/*.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"test/**/*.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["使用 ", _jsx(_components.code, {
          children: "inputs"
        }), " 键将使你退出 ", _jsx(_components.code, {
          children: "turbo"
        }), " 考虑 ", _jsx(_components.code, {
          children: ".gitignore"
        }), " 的默认行为。你必须根据需要从 ", _jsx(_components.code, {
          children: ".gitignore"
        }), " 重建 glob，或者使用 ", _jsx(_components.code, {
          children: "$TURBO_DEFAULT$"
        }), " 构建默认行为。"]
      }), _jsxs(_components.p, {
        children: ["¥Using the ", _jsx(_components.code, {
          children: "inputs"
        }), " key opts you out of ", _jsx(_components.code, {
          children: "turbo"
        }), "'s default behavior of\nconsidering ", _jsx(_components.code, {
          children: ".gitignore"
        }), ". You must reconstruct the globs from ", _jsx(_components.code, {
          children: ".gitignore"
        }), " as\ndesired or use ", _jsx(_components.code, {
          children: "$TURBO_DEFAULT$"
        }), " to build off of the default behavior."]
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "turbo_default-turbodefault",
      children: [_jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["由于指定 ", _jsx(_components.code, {
        children: "inputs"
      }), " 键会立即退出默认行为，因此你可以在 ", _jsx(_components.code, {
        children: "inputs"
      }), " 数组中使用特殊字符串 ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " 来恢复 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的默认行为。这允许你调整默认行为以获得更精细的粒度。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Because specifying an ", _jsx(_components.code, {
        children: "inputs"
      }), " key immediately opts out of the default behavior, you may use\nthe special string ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " within the ", _jsx(_components.code, {
        children: "inputs"
      }), " array to restore ", _jsx(_components.code, {
        children: "turbo"
      }), "'s default behavior. This allows you to tweak the default behavior for more granularity."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Consider all default inputs except the package's README"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!README.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h4, {
      id: "turbo_root-turboroot",
      children: [_jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "任务可能会引用其目录之外的文件。"
    }), "\n", _jsx(_components.p, {
      children: "¥Tasks might reference a file that lies outside of their directory."
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " 启动文件 glob 会将 glob 更改为相对于仓库根目录，而不是包目录。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Starting a file glob with ", _jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " will change the glob to be relative to the root of the repository instead of the package directory."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Consider all Typescript files in `src/` and the root tsconfig.json as inputs"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_ROOT$/tsconfig.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"src/**/*.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h4, {
      id: "turbo_extends-turboextends",
      children: [_jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "软件包配置"
      }), " 时，数组字段默认会完全替换根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中的值。", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), " 微语法将此行为更改为追加而非替换。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When using ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configurations"
      }), ", array fields completely replace the values from the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " by default. The ", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), " microsyntax changes this behavior to ", _jsx(_components.strong, {
        children: "append"
      }), " instead of ", _jsx(_components.strong, {
        children: "replace"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "此微语法可用于以下数组字段："
    }), "\n", _jsx(_components.p, {
      children: "¥This microsyntax can be used in the following array fields:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "dependsOn"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "env"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "inputs"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "outputs"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "passThroughEnv"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "with"
          })
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["例如，如果你的根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 定义了："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For example, if your root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " defines:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "包配置可以在保留根输出的同时添加额外的输出："
    }), "\n", _jsx(_components.p, {
      children: "¥A Package Configuration can add additional outputs while keeping the root outputs:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Inherits \"dist/**\" from root, and adds \".next/**\""
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_EXTENDS$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果没有 ", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), "，", _jsx(_components.code, {
        children: "outputs"
      }), " 数组将被 ", _jsx(_components.code, {
        children: "[\".next/**\", \"!.next/cache/**\"]"
      }), " 完全替换，根配置中的 ", _jsx(_components.code, {
        children: "\"dist/**\""
      }), " 将被删除。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Without ", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), ", the ", _jsx(_components.code, {
        children: "outputs"
      }), " array would be completely replaced with ", _jsx(_components.code, {
        children: "[\".next/**\", \"!.next/cache/**\"]"
      }), ", dropping the ", _jsx(_components.code, {
        children: "\"dist/**\""
      }), " from the root configuration."]
    }), "\n", _jsxs(_components.h3, {
      id: "outputlogs-outputlogs",
      children: [_jsx(_components.code, {
        children: "outputLogs"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "full"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "full"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置输出日志详细程度。可以被 ", _jsx(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: _jsx(_components.code, {
          children: "--output-logs"
        })
      }), " CLI 选项覆盖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Set output logging verbosity. Can be overridden by the ", _jsx(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: _jsx(_components.code, {
          children: "--output-logs"
        })
      }), " CLI option."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "选项"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "full"
            })
          }), _jsx(_components.td, {
            children: "显示所有日志"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hash-only"
            })
          }), _jsx(_components.td, {
            children: "仅显示任务的哈希值"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "new-only"
            })
          }), _jsx(_components.td, {
            children: "仅显示缓存未命中的日志"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "errors-only"
            })
          }), _jsx(_components.td, {
            children: "仅显示任务失败的日志"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "none"
            })
          }), _jsx(_components.td, {
            children: "隐藏所有任务日志"
          })]
        })]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputLogs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"new-only\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "persistent-persistent",
      children: [_jsx(_components.code, {
        children: "persistent"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["将任务标记为 ", _jsx(_components.code, {
        children: "persistent"
      }), "，以防止其他任务依赖于长时间运行的进程。持久任务默认为 ", _jsx(_components.a, {
        href: "#interactive",
        children: "interactive"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Label a task as ", _jsx(_components.code, {
        children: "persistent"
      }), " to prevent other tasks from depending on long-running processes. Persistent tasks are made ", _jsx(_components.a, {
        href: "#interactive",
        children: "interactive"
      }), " by default."]
    }), "\n", _jsxs(_components.p, {
      children: ["由于长时间运行的进程不会退出，因此依赖于它的任务将永远不会运行。将任务标记为持久任务后，如果其他任务依赖于该任务，", _jsx(_components.code, {
        children: "turbo"
      }), " 将会抛出错误。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Because a long-running process won't exit, tasks that would depend on it would never run. Once you've labeled the task as persistent, ", _jsx(_components.code, {
        children: "turbo"
      }), " will throw an error if other tasks depend on it."]
    }), "\n", _jsx(_components.p, {
      children: "此选项对于开发服务器或其他 \"watch\" 任务最有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥This option is most useful for development servers or other \"watch\" tasks."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，标有 ", _jsx(_components.code, {
        children: "persistent"
      }), " 的任务也是 ", _jsx(_components.code, {
        children: "interactive"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Tasks marked with ", _jsx(_components.code, {
        children: "persistent"
      }), " are also ", _jsx(_components.code, {
        children: "interactive"
      }), " by default."]
    }), "\n", _jsxs(_components.h3, {
      id: "interactive-interactive",
      children: [_jsx(_components.code, {
        children: "interactive"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      }), "（对于标记为 ", _jsx(_components.code, {
        children: "persistent"
      }), " 的任务，默认为 ", _jsx(_components.code, {
        children: "true"
      }), "）"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      }), " (Defaults to ", _jsx(_components.code, {
        children: "true"
      }), " for tasks marked as ", _jsx(_components.code, {
        children: "persistent"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["将任务标记为 ", _jsx(_components.code, {
        children: "interactive"
      }), "，使其在终端 UI 中接受来自 ", _jsx(_components.code, {
        children: "stdin"
      }), " 的输入。必须与 ", _jsx(_components.code, {
        children: "persistent"
      }), " 一起使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Label a task as ", _jsx(_components.code, {
        children: "interactive"
      }), " to make it accept inputs from ", _jsx(_components.code, {
        children: "stdin"
      }), " in the terminal UI. Must be used with ", _jsx(_components.code, {
        children: "persistent"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "此选项对于可以在运行时操作的脚本（例如 Jest 或 Vitest）最有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥This option is most useful for scripts that can be manipulated while they are running, like Jest or Vitest."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test:watch\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"interactive\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "interruptible-interruptible",
      children: [_jsx(_components.code, {
        children: "interruptible"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["将 ", _jsx(_components.code, {
        children: "persistent"
      }), " 任务标记为 ", _jsx(_components.code, {
        children: "interruptible"
      }), "，以允许 ", _jsx(_components.code, {
        children: "turbo watch"
      }), " 重新启动它。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Label a ", _jsx(_components.code, {
        children: "persistent"
      }), " task as ", _jsx(_components.code, {
        children: "interruptible"
      }), " to allow it to be restarted by ", _jsx(_components.code, {
        children: "turbo watch"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), " 监视包的更改并自动重启受影响的任务。但是，如果任务是持久性的，则默认情况下不会重新启动。要启用重新启动持久任务，请将 ", _jsx(_components.code, {
        children: "interruptible"
      }), " 设置为 ", _jsx(_components.code, {
        children: "true"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo watch"
      }), " watches for changes to your packages and automatically restarts tasks\nthat are affected. However, if a task is persistent, it will not be restarted by default.\nTo enable restarting persistent tasks, set ", _jsx(_components.code, {
        children: "interruptible"
      }), " to ", _jsx(_components.code, {
        children: "true"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "with-with",
      children: [_jsx(_components.code, {
        children: "with"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "将与此任务一起运行的任务列表。这对于需要确保始终同时运行的长时间运行任务非常有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥A list of tasks that will be ran alongside this task. This is most useful for long-running tasks that you want to ensure always run at the same time."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"with\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"api#dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "边界-boundaries",
      children: "边界 "
    }), "\n", _jsx(_components.p, {
      children: "¥Boundaries"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "boundaries"
      }), " 标签允许你为 ", _jsxs(_components.a, {
        href: "/docs/reference/boundaries",
        children: [_jsx(_components.code, {
          children: "boundaries"
        }), " 命令"]
      }), " 定义规则。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "boundaries"
      }), " tag allows you to define rules for the ", _jsxs(_components.a, {
        href: "/docs/reference/boundaries",
        children: [_jsx(_components.code, {
          children: "boundaries"
        }), " command"]
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "tags-tags",
      children: [_jsx(_components.code, {
        children: "tags"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tags"
      }), " 对象中的每个键都是一个可以使用 ", _jsx(_components.a, {
        href: "/docs/reference/boundaries",
        children: _jsx(_components.code, {
          children: "turbo boundaries"
        })
      }), " 检查的标签名称。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Each key in the ", _jsx(_components.code, {
        children: "tags"
      }), " object is the name of a tag that can be checked with ", _jsx(_components.a, {
        href: "/docs/reference/boundaries",
        children: _jsx(_components.code, {
          children: "turbo boundaries"
        })
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "在标签的配置对象中，你可以定义依赖和被依赖的规则。"
    }), "\n", _jsx(_components.p, {
      children: "¥In the configuration object for a tag, you can define rules for dependencies and dependents."
    }), "\n", _jsxs(_components.h4, {
      id: "dependencies-和-dependents-dependencies-and-dependents",
      children: [_jsx(_components.code, {
        children: "dependencies"
      }), " 和 ", _jsx(_components.code, {
        children: "dependents"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "dependencies"
      }), " and ", _jsx(_components.code, {
        children: "dependents"
      })]
    }), "\n", _jsx(_components.p, {
      children: "标签依赖和依赖的规则。"
    }), "\n", _jsx(_components.p, {
      children: "¥Rules for a tag's dependencies and dependents."
    }), "\n", _jsx(_components.p, {
      children: "你可以添加允许列表和拒绝列表："
    }), "\n", _jsx(_components.p, {
      children: "¥You can add an allowlist and a denylist:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"utils\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // permit only packages with the `ui` tag"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"allow\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // and ban packages with the `unsafe` tag"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"deny\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"unsafe\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "允许列表和拒绝列表都可以省略。"
    }), "\n", _jsx(_components.p, {
      children: "¥Both the allowlist and the denylist can be omitted."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"utils\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // only packages with the `unsafe` tag are banned, all other packages permitted"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"deny\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"unsafe\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "还可以为标签的依赖（即导入此标签的包）添加规则。"
    }), "\n", _jsx(_components.p, {
      children: "¥Rules can also be added for a tag's dependents, i.e. packages that import this tag."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"utils\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependents\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // only packages with the `web` tag can import packages with the `utils` tag"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"allow\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"web\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "远程缓存-remote-caching",
      children: "远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Remote caching"
    }), "\n", _jsxs(_components.p, {
      children: ["全局 ", _jsx(_components.code, {
        children: "remoteCache"
      }), " 选项包含各种字段，用于配置远程缓存的使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The global ", _jsx(_components.code, {
        children: "remoteCache"
      }), " option has a variety of fields for configuring remote cache usage"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"remoteCache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "enabled-enabled",
      children: [_jsx(_components.code, {
        children: "enabled"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsx(_components.p, {
      children: "启用远程缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥Enables remote caching."
    }), "\n", _jsxs(_components.p, {
      children: ["当 ", _jsx(_components.code, {
        children: "false"
      }), " 匹配时，Turborepo 将禁用所有远程缓存操作，即使仓库拥有有效的令牌。如果为 true，则启用远程缓存，但仍需要用户登录并将其代码库链接到远程缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When ", _jsx(_components.code, {
        children: "false"
      }), ", Turborepo will disable all remote cache operations, even if the repo has a valid token.\nIf true, remote caching is enabled, but still requires the user to login and link their repo to a remote cache."]
    }), "\n", _jsxs(_components.h3, {
      id: "signature-signature",
      children: [_jsx(_components.code, {
        children: "signature"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["允许对远程缓存请求进行签名验证。当 ", _jsx(_components.code, {
        children: "true"
      }), " 匹配时，Turborepo 将使用环境变量 ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), " 的值对每个上传的工件进行签名。Turborepo 将拒绝任何签名无效或缺少签名的下载工件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Enables signature verification for requests to the remote cache.\nWhen ", _jsx(_components.code, {
        children: "true"
      }), ", Turborepo will sign every uploaded artifact using the value of the environment variable ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), ".\nTurborepo will reject any downloaded artifacts that have an invalid signature or are missing a signature."]
    }), "\n", _jsxs(_components.h3, {
      id: "preflight-preflight",
      children: [_jsx(_components.code, {
        children: "preflight"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "启用后，任何 HTTP 请求之前都会有一个 OPTIONS 请求，以确定端点是否支持该请求。"
    }), "\n", _jsx(_components.p, {
      children: "¥When enabled, any HTTP request will be preceded by an OPTIONS request to determine if the request is supported by the endpoint."
    }), "\n", _jsxs(_components.h3, {
      id: "timeout-timeout",
      children: [_jsx(_components.code, {
        children: "timeout"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "30"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "30"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置远程缓存操作的超时时间。值以秒为单位，并且只接受整数。如果已传递 ", _jsx(_components.code, {
        children: "0"
      }), "，则任何缓存操作均不会超时。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sets a timeout for remote cache operations.\nValue is given in seconds and only whole values are accepted.\nIf ", _jsx(_components.code, {
        children: "0"
      }), " is passed, then there is no timeout for any cache operations."]
    }), "\n", _jsxs(_components.h3, {
      id: "uploadtimeout-uploadtimeout",
      children: [_jsx(_components.code, {
        children: "uploadTimeout"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "60"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "60"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置远程缓存上传的超时时间。值以秒为单位，并且只接受整数。如果已传递 ", _jsx(_components.code, {
        children: "0"
      }), "，则任何远程缓存上传均不会超时。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sets a timeout for remote cache uploads.\nValue is given in seconds and only whole values are accepted.\nIf ", _jsx(_components.code, {
        children: "0"
      }), " is passed, then there is no timeout for any remote cache uploads."]
    }), "\n", _jsxs(_components.h3, {
      id: "apiurl-apiurl",
      children: [_jsx(_components.code, {
        children: "apiUrl"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "\"https://vercel.com\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "\"https://vercel.com\""
      })]
    }), "\n", _jsx(_components.p, {
      children: "设置远程缓存 API 调用的端点。"
    }), "\n", _jsx(_components.p, {
      children: "¥Set endpoint for API calls to the remote cache."
    }), "\n", _jsxs(_components.h3, {
      id: "loginurl-loginurl",
      children: [_jsx(_components.code, {
        children: "loginUrl"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["默认：", _jsx(_components.code, {
        children: "\"https://vercel.com\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Default: ", _jsx(_components.code, {
        children: "\"https://vercel.com\""
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["设置在 ", _jsx(_components.code, {
        children: "turbo login"
      }), " 期间请求令牌的端点。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Set endpoint for requesting tokens during ", _jsx(_components.code, {
        children: "turbo login"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "teamid-teamid",
      children: [_jsx(_components.code, {
        children: "teamId"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["远程缓存团队的 ID。值将作为 ", _jsx(_components.code, {
        children: "teamId"
      }), " 在所有远程缓存 HTTP 调用的查询字符串中传递。必须以 ", _jsx(_components.code, {
        children: "team_"
      }), " 开头，否则将无法使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ID of the Remote Cache team.\nValue will be passed as ", _jsx(_components.code, {
        children: "teamId"
      }), " in the querystring for all Remote Cache HTTP calls.\nMust start with ", _jsx(_components.code, {
        children: "team_"
      }), " or it will not be used."]
    }), "\n", _jsxs(_components.h3, {
      id: "teamslug-teamslug",
      children: [_jsx(_components.code, {
        children: "teamSlug"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["远程缓存团队的 slug。值将作为 ", _jsx(_components.code, {
        children: "slug"
      }), " 在所有远程缓存 HTTP 调用的查询字符串中传递。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The slug of the Remote Cache team.\nValue will be passed as ", _jsx(_components.code, {
        children: "slug"
      }), " in the querystring for all Remote Cache HTTP calls."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
